"use client";

import { cn } from "@repo/shared/utils";
import { cva, type VariantProps } from "class-variance-authority";
import type { ClassNameValue } from "tailwind-merge";

const spinnerVariants = cva(
  "inline-block border-current border-t-transparent animate-spin rounded-full border-solid align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]",
  {
    variants: {
      variant: {
        default: "text-primary",
        destructive: "text-destructive",
        secondary: "text-secondary",
        ghost: "text-accent",
      },
      size: {
        default: "h-8 w-8 border-4",
        sm: "h-5 w-5 border-[3px]",
        lg: "h-12 w-12 border-8",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

interface SpinnerProps extends VariantProps<typeof spinnerVariants> {
  className?: ClassNameValue;
}
export const Spinner = ({ className, variant, size }: SpinnerProps) => {
  return (
    <div
      className={cn(spinnerVariants({ variant, size, className }))}
      role="status"
    >
      <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
        Loading...
      </span>
    </div>
  );
};
